import { useState } from "react";
import { Link } from "react-router-dom";
import styles from "../../Dashboard.module.css";

const Actions = ({ grantId, idMonitorado }) => {

    return (
        <div className={styles.actionsContainer}>
            <Link
                to={`/monitorado/${idMonitorado}/editar`}
                className={styles.primaryButton}
            >
                <i className="fa fa-pen" />
                Editar monitorado
            </Link>

            <Link
                to={`/ambiental/outorga/${grantId}/editar`}
                className={styles.secondaryButton}
            >
                <i className="fa fa-file-contract" />
                Editar outorga
            </Link>
        </div>
    );
}

export default Actions;